import { Heading } from '@/components/Cms/Heading';
import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type { ContentfulImageWithFocalPointFragment } from '@/graphql/contentful/api';

import type { CardProps } from '../../types';

import * as S from './TopBanner.styles';

export const TopBanner = ({
  aspectRatio,
  className,
  headingTextColor,
  media,
  mediaWrapperType,
  placeholderHeading,
  preload,
  sizes,
  visibleInDesktop,
  visibleInMobile,
}: CardProps) => {
  return (
    <S.TopBannerWrapper
      $visibleInDesktop={visibleInDesktop}
      $visibleInMobile={visibleInMobile}
      className={className}
    >
      <MediaWrapper
        aspectRatio={aspectRatio}
        mediaWrapperType={mediaWrapperType}
        {...(media as ContentfulImageWithFocalPointFragment)}
        data-test-id='TopBannerMediaWrapper'
        preload={preload}
        sizes={sizes}
      />
      <S.Wrapper>
        <S.Content data-test-id='TopBannerContent'>
          {placeholderHeading && (
            <S.Heading data-test-id='TopBannerHeading'>
              <Heading
                Heading={placeholderHeading}
                color={placeholderHeading?.mainColor ?? headingTextColor}
                sizeDesktop={50}
                sizeMobile={40}
              />
            </S.Heading>
          )}
        </S.Content>
      </S.Wrapper>
    </S.TopBannerWrapper>
  );
};
